import React, { useState, useEffect } from "react";
import { Upload, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const ComUpImg = ({
  onChange,
  numberImg,
  listType,
  multiple,
  inputId,
  required,
  label,
  resetFileList, // New prop to reset fileList from parent
}) => {
  const [fileList, setFileList] = useState([]);
  const maxImages = numberImg || 15;

  useEffect(() => {
    setFileList([]); // Reset fileList when resetFileList is true
  }, [resetFileList]);

  const isImageFile = (file) => {
    const acceptedFormats = [".jpeg", ".jpg", ".png", ".gif"];
    const fileExtension = file.name.toLowerCase();

    if (!acceptedFormats.some((format) => fileExtension.endsWith(format))) {
      message.error("Only image files are allowed to be selected.");
      return false; // Prevent upload if it's not an image
    }

    return true;
  };

  const handleFileChange = ({ fileList }) => {
    const filteredFileList = fileList.filter((file) => isImageFile(file));
    if (filteredFileList.length > maxImages) {
      message.error(`Only select up to ${maxImages} photos.`);
      const firstFiveImages = filteredFileList.slice(0, maxImages);
      setFileList(firstFiveImages);
      onChange(firstFiveImages);
    } else {
      setFileList(filteredFileList);
      onChange(filteredFileList);
    }
  };

  return (
    <>
      {label && (
        <div className="mb-4 flex justify-between">
          <label htmlFor={inputId} className="text-paragraph font-medium">
            {label}
            {required && (
              <span className="text-paragraph font-medium text-error-7 text-red-500">
                *
              </span>
            )}
          </label>
        </div>
      )}
      <Upload
        fileList={fileList}
        listType={listType || "picture-card"}
        onChange={handleFileChange}
        beforeUpload={() => false} // Prevent automatic upload
        accept=".jpg,.jpeg,.png,.gif" // Allow only image files
        multiple={multiple || true} // Allow selecting multiple files
      >
        <PlusOutlined />
      </Upload>
    </>
  );
};

export default ComUpImg;
